<div id="wrapper">
  <mat-card id="shutdown-card">
    <mat-card-content id="message">
      {{ 'System is failing over...' | translate }}
    </mat-card-content>
    <ix-icon name="ix:logo_truenas_scale_full" class="logo"></ix-icon>
    <div>
      <span fxFlex class="copyright-txt">
        <ix-copyright-line></ix-copyright-line>
      </span>
    </div>
  </mat-card>
</div>
